import { useContext } from 'react';

import { BrandContext } from './brand-context';

export const useBrand = () => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useContext(BrandContext)!;
};
